<template>
  <template v-if="envName === 'stater'">
    <div id="QRPay" style="height: 200px;">
      <div class="qrpay_text">
        <h3>Оплачивайте товары и услуги</h3>
        <p>Теперь вы можете оплатить товары и услуги, используя кошелек «СТАТЕРА»</p>
        <br />
        <p><button @click="marketModalActive = true" class="main_btn">перейти в маркет</button></p>    

      </div>
      <div class="qrpay_img">
        <div class="qrpay_bg">
          <div class="prpay_bg_in"></div>
          <div class="main_images">
            <img class="main_img" src="@/assets/images/qr_pay_qr.png" alt="">
            <img class="avatar_icon" src="@/assets/images/avatar.svg" alt="">
          </div>
          <img class="hand_img" src="@/assets/images/hand_money.png" alt="">
          <!-- <img class="close_img" src="@/assets/images/qrpay_close.svg" alt=""> -->
        </div>
      </div>
    </div>

    <TextModal                
          @closeModal="marketModalActive = false" 
          v-if="marketModalActive" 
          title=""  
          text="Маркет временно недоступен." />      
  </template>
  <template v-else>
    <div id="QRPay" >
      <div class="qrpay_text">
        <h3>{{text('qr_payment.title')}}</h3>
        <p>{{text('qr_payment.description')}}</p>
      </div>
      <div class="qrpay_img">
        <div class="qrpay_bg">
          <div class="prpay_bg_in"></div>
          <div class="main_images">
            <img class="main_img" src="@/assets/images/qr_pay_qr.png" alt="">
            <img class="avatar_icon" src="@/assets/images/avatar.svg" alt="">
          </div>
          <img class="hand_img" src="@/assets/images/hand_money.png" alt="">
          <!-- <img class="close_img" src="@/assets/images/qrpay_close.svg" alt=""> -->
        </div>
      </div>
    </div> 
  </template>  
</template>

<script>
import TextModal from '../components/TextModal.vue';

export default {
    name: "QRPay",
    components: {
        TextModal
    },
    data() {
        return {
            marketModalActive: false,
        }
    },          
};
</script>